import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-4" }, "Featured Creators", -1)
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-9 gap-4 lg:gap-8" }
const _hoisted_3 = { class: "lg:col-span-5" }
const _hoisted_4 = { class: "flex flex-col w-full space-y-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreatorsListItem = _resolveComponent("CreatorsListItem")!
  const _component_CreatorsFeaturedItem = _resolveComponent("CreatorsFeaturedItem")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creators.slice(0, 4), (creator) => {
            return (_openBlock(), _createBlock(_component_CreatorsListItem, {
              key: creator.username,
              creator: creator
            }, null, 8, ["creator"]))
          }), 128))
        ])
      ]),
      _createVNode(_component_CreatorsFeaturedItem, {
        class: "order-first lg:order-none lg:col-span-4",
        creator: _ctx.creators[4]
      }, null, 8, ["creator"])
    ])
  ]))
}